import { createSimpleLifecycle } from "./lifecycle";
export function onWillUnmount(callback) {
    return createSimpleLifecycle("componentWillUnmountCallback", callback);
}
export default onWillUnmount;

//# sourceMappingURL=onWillUnmount.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/onWillUnmount.js
// module id = 55
// module chunks = 0